import type { Device } from "../../types/device";
import type { Person, ProveedorPersonFormData } from "../../types/person";
import { apiClient } from "../core/apiClient";


interface getPersonResult {
  data: Person[];
  pagination: {
    currentPage: number,
    totalPages: number,
    totalItems: number,
    itemsPerPage: number,
    itemsInCurrentPage: number,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
    nextPage: string | null,
    previousPage: string | null
  }
  loading: boolean;
  error: string | null;
  total: number;
  totalPages: number;
  refetch: () => void;
}

interface postPersonResult {
  user: {
    employeeNo: string,
    name: string,
    userType: string,
    doorRight: string
  }
}


export class DeviceService {

  async getDevices(): Promise<Device[]> {
    const response = await apiClient.get<Device[]>(`/devices`);
    return response.data;
  }

  async openDoor(facialId: number): Promise<Boolean> {
    const response = await apiClient.get<Device[]>(`/abrir-puerta/abrir/${facialId}`);
    return response.state;
  }




  async createPerson(namePerson: string): Promise<postPersonResult> {
    const response = await apiClient.post<postPersonResult>('/personas/add', { "name": namePerson });
    return response.data;
  }

  async addProveedorPerson(proveedorData: ProveedorPersonFormData): Promise<Boolean> {
    const response = await apiClient.post<postPersonResult>('/personas/add-type-proveedor', proveedorData);
    return response.state;
  }

  async addPhotoPerson(userId: string, file: File): Promise<Boolean> {
    const response = await apiClient.uploadFile<{ avatarUrl: string }>(`/personas/add-photo/${userId}`, file);
    return response.state;
  }

  async syncFacial(facialId: string): Promise<Boolean> {
    const response = await apiClient.get<getPersonResult>(`/sincronizar-facial/${facialId}`);
    return response.state;
  }

  async updatePersonStatus(personId: string, statusId: number): Promise<void> {

    const response = await apiClient.post(`/personas/change-status`, {
      employeeNo: personId,
      status: statusId
    });
    return response.data;
  }
}

export const deviceService = new DeviceService();